/** @format */

import { useNavigate } from "react-router-dom";
import { Container } from "../herosectionhome/herosectionhome.style";

import LiveEditImageHighLighter from "../../../../liveEditHighlighterstyles/liveEditImageHighLighter.component";
import LiveEdithTextHighLighter from "../../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component";
import {
  isImage,
  isVideo,
} from "../../../../utils/Helper_functions/VideoAndImage";

type Section6Props = {
  data?: Record<string, any>;
};

export default function Section6({ data }: Section6Props) {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(`../idxlisting/`);
  };

  return (
    <Container id="sec9" $color={data.color} className="sec1">
      <div className="HomeContainer">
        <div className="overlay"></div>
        <div className="leftSection">
          <LiveEdithTextHighLighter section="sec10" type="text">
            <div
              className="Text"
              style={{
                fontFamily: "Tenor Sans, sans-serif",
                fontSize: "clamp(1.5rem, 5vw, 3rem)", // Responsive h1
                lineHeight: "1.3",
                textAlign: "left",
                fontWeight: "bold",
                marginBottom: "1rem",
              }}
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
          </LiveEdithTextHighLighter>

          <LiveEdithTextHighLighter section="sec10" type="description">
            <div
              className="description"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "clamp(1rem, 2.5vw, 1.5rem)", // Responsive paragraph
                lineHeight: "1.6",
                textAlign: "left",
              }}
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </LiveEdithTextHighLighter>
        </div>
        {/* Conditional Rendering for Image or Video */}
        {isImage(data?.image) ? (
          <img
            src={`/public/${data?.image}`}
            alt="HomeImage"
            loading="lazy"
            className="backgroundImage"
          />
        ) : isVideo(data?.image) ? (
          <video
            src={`/public/${data?.image}`}
            className="backgroundImage"
            autoPlay
            loop
            muted
          />
        ) : (
          <iframe
            className="backgroundImage"
            src={`https://www.youtube.com/embed/${data?.image}?autoplay=1&mute=1&loop=1&playlist=${data?.image}&controls=0&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              minWidth: "100%",
              objectFit: "cover",
              border: "none",
              aspectRatio: "16/9",
              height: "95vh",
              minHeight: "56vw",
            }}
          ></iframe>
        )}
      </div>
    </Container>
  );
}
